import { ChangeDetectionStrategy, Component, OnInit, output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LoginService } from '../../auth/login.service';
import { markBirthdayCelebrationSeen, pickCrmBirthdayMessage } from './birthday-celebration.utils';

@Component({
  selector: 'app-birthday-celebration',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './birthday-celebration.component.html',
  styleUrl: './birthday-celebration.component.scss',
})
export class BirthdayCelebrationComponent implements OnInit {
  private readonly login = inject(LoginService);

  readonly dismissed = output<void>();
  readonly firstName = signal('friend');
  readonly message = signal('');
  readonly pieces = Array.from({ length: 48 }, (_, i) => ({
    id: i,
    left: `${(i * 17 + 7) % 100}%`,
    delay: `${(i % 12) * 0.12}s`,
    duration: `${2.4 + (i % 5) * 0.35}s`,
    hue: (i * 47) % 360,
    size: 6 + (i % 5) * 2,
  }));

  ngOnInit(): void {
    const user = this.login.getUser();
    const name = user?.contact?.firstName?.trim() || user?.firstName?.trim() || 'friend';
    this.firstName.set(name);
    this.message.set(pickCrmBirthdayMessage());
  }

  onDismiss(): void {
    const user = this.login.getUser();
    if (user?.id) {
      markBirthdayCelebrationSeen(user.id);
    }
    this.dismissed.emit();
  }
}
